import {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'

function parseURL(url: string) {
  const parser = document.createElement('a')
  const searchObject: any = {}
  let split
  let i
  // Let the browser do the work
  parser.href = url
  // Convert query string to object
  const queries = parser.search.replace(/^\?/, '').split('&')
  for (i = 0; i < queries.length; i++) {
    split = queries[i].split('=')
    searchObject[split[0]] = split[1]
  }
  return {
    protocol: parser.protocol,
    host: parser.host,
    hostname: parser.hostname,
    port: parser.port,
    pathname: parser.pathname,
    search: parser.search,
    searchObject,
    hash: parser.hash,
  }
}

export default class UiBlockingCondition {

  private routeName?: string | null
  private requestConfig?: AxiosRequestConfig
  private response?: AxiosResponse<any>

  public constructor(fields?: {
    routeName?: string | null,
    requestConfig?: AxiosRequestConfig,
    response?: AxiosResponse<any>,
  }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }

  public isFromLoginPage(): boolean {
    if (this.routeName && this.routeName === 'login') {
      return true
    }
    return false
  }

  private getUrl(): string {
    if (this.requestConfig) {
      return this.requestConfig.url || ''
    }
    if (this.response) {
      return parseURL(this.response.request.responseURL).pathname
    }
    throw(Error(`Cannot get url from condition object ${this}`))
  }

  private getQueryByKey(key: string): string {
    if (this.requestConfig) {
      return this.requestConfig.params && this.requestConfig.params[key]
    }
    if (this.response) {
      return this.response.config && this.response.config.params[key]
    }
    throw(Error(`Cannot get query by key: ${key} from condition object ${this}`))
  }

}
